module.exports = __webpack_public_path__ + "img/couples-064.8deec3ec.jpg";